/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React from "react";

import { Box, Image, Stack } from "grommet";

const LogoVertical = () => (
    <Stack anchor="center">
        <Box
                width="large"
                height="xxsmall"
                // round="small"
                align="center"
                justify="center"
        >
        <Image
            fit={"cover"}
            src="Veggit_Vertical_Transparent.png"
        />
        </Box>
    </Stack>
);

export default LogoVertical;
